import { render, staticRenderFns } from "./pending-pickup.vue?vue&type=template&id=40a9ee20&"
import script from "./pending-pickup.vue?vue&type=script&lang=js&"
export * from "./pending-pickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports